import * as CounterService from "../../services/counter-service";

export const NOT_SET = -1;

const REFRESH_TIMER = 30 * 1000; // 30 seconds in millis
let timerId;

export function register(callback) {
    fetchCounter(callback);
    unregister();
    timerId = setInterval(function () {
        fetchCounter(callback);
    }, REFRESH_TIMER);
}

export function fetchCounter(callback) {
    CounterService.getMenuCounters()
        .then(response => {
            callback(response.data.count1, response.data.count2)
        }).catch(err => {
        callback(NOT_SET, NOT_SET);
    });

}

export function unregister() {
    clearInterval(timerId);
}